import { createElement } from 'react';
import { mkRoutes } from './_';
import { districtUrls } from './urls/district';
import PageLayout from '../../layout/page-layout';
import DistrictHomePage from '../../screens/district/homepage';
import PropertiesPage from '../../screens/district/properties';
import AnnouncementsPage from '../../screens/district/announcements';
import AnnouncementDetailPage from '../../screens/district/announcements/detail';
import DiscussionPage from '../../screens/district/discussion-page';
import DistrictDiscussionNew from '../../screens/district/discussions/new';
import DistrictDiscussionDetail from '../../screens/district/discussions/detail';
import FaqPage from '../../screens/district/faq-page';
import MissionPage from '../../screens/district/mission-page';
import ResourcesPage from '../../screens/district/resources';
import EventsPage from '../../screens/district/events';
import EventDetailPage from '../../screens/district/events/detail';
import ToursPage from '../../screens/district/tours';
import TourDetailPage from '../../screens/district/tours/detail';
import TourMapPage from '../../screens/district/tours/map';
import TourHomePage from '../../screens/district/tours/home';
import TourHomePhotosPage from '../../screens/district/tours/photos';
import AboutPage from '../../screens/district/about';
import Policy from '../../screens/district/policy';
export const [districtRoutes, districtRoutesArray] = mkRoutes(districtUrls, {
    home: DistrictHomePage,
    properties: PropertiesPage,
    announcements: AnnouncementsPage,
    announcementsDetail: AnnouncementDetailPage,
    discussions: DiscussionPage,
    discussionsNew: DistrictDiscussionNew,
    discussionsDetail: ({ id }) => DistrictDiscussionDetail({ id }),
    faqs: FaqPage,
    mission: MissionPage,
    resources: ResourcesPage,
    events: EventsPage,
    eventsDetail: EventDetailPage,
    tours: () => createElement(PageLayout, { 'children': createElement(ToursPage) }),
    toursDetail: ({ id }) => createElement(PageLayout, { 'navbar': 'tour', 'children': createElement(TourDetailPage, { id }) }),
    toursMap: ({ id }) => createElement(PageLayout, { 'navbar': 'tour', 'children': createElement(TourMapPage, { id }) }),
    toursHome: ({ id, stopId }) => createElement(PageLayout, { 'navbar': 'tour', 'children': createElement(TourHomePage, { id, stopId }) }),
    toursHomePhotos: ({ id, stopId }) => createElement(PageLayout, { 'navbar': 'tour', 'children': createElement(TourHomePhotosPage, { id, stopId }) }),
    about: AboutPage,
    policy: Policy,
});
